module.exports = __webpack_public_path__ + "img/1440.ebaa6e36.jpg";